import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ErrorUI } from '../components/UI/Modals/Modals';
import { PostMethod } from '../services/CallApi';
import { sortData } from '../services/CommonFunction';
import { staticVar } from '../services/Constants';
import { setCoach } from '../services/SetApiResponse';
import { messageService, userData } from '../services/subscriberService';

const initialState = {
    list: {
        coach: [],
        owner: [],
    },
    status: staticVar.idle
};

export const getCollaboratorList =  createAsyncThunk('_getCollaborator', async (data,{ dispatch, rejectWithValue }) => {
    try {
        messageService.show = false;
        const data = {
            gym_id: userData.selectedGym.gym_id,
        }
        const response = await PostMethod('_getCollaborator',data);
        const coach = response.data.data.coaches.map(el => (setCoach(el))).sort(sortData);
        const owner = response.data.data.owner.map(el => (setCoach(el))).sort(sortData);
        return {coach,owner};
    } catch (err) {
        if (!err.response) {
            throw err
        }
        if(err.response.data.statusCode === 401) {
            ErrorUI(err.response.data);
        }
        return rejectWithValue({err: err.response.data,id: data.id,updated: data.updated})
    }
});

const collaboratorDataSlice = createSlice({
    name: 'collaboratorData',
    initialState,
    reducers: {
        resetCollaborator: (state) => {
            state.list = {
                coach: [],
                owner: [],
            }; 
            state.status = staticVar.idle;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCollaboratorList.pending, (state,action) => {
                state.status = staticVar.loading;
            })
            .addCase(getCollaboratorList.fulfilled, (state,action) => {
                // const list = {...state.list};
                // if(CheckValue(list)) {
                //     action.payload.forEach(element => {
                //         list.push(element);
                //     });
                // }
                state.list = {...action.payload};
                state.status = staticVar.idle;
            })
            .addCase(getCollaboratorList.rejected, (state,action) => {
                state.status = staticVar.idle;
                // ErrorUI(action.payload.err);
            })
    }
});

export const getAllCollaborator = (state) => state.collaboratorData;
export const { resetCollaborator } = collaboratorDataSlice.actions;
export default collaboratorDataSlice.reducer;